import { render, staticRenderFns } from "./blessItem.vue?vue&type=template&id=419c87dc&scoped=true"
import script from "./blessItem.vue?vue&type=script&lang=js"
export * from "./blessItem.vue?vue&type=script&lang=js"
import style0 from "./blessItem.vue?vue&type=style&index=0&id=419c87dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419c87dc",
  null
  
)

export default component.exports